import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { RoleService } from '../services/role.service';

/**
 * Redirects `/` under AppShell to the role default route (first sidebar item).
 * AuthGuard already ran on the parent; use RoleService so the landing path matches RoleGuard.
 */
export const appDefaultRedirectGuard: CanActivateFn = () => {
  const roleService = inject(RoleService);
  const router = inject(Router);

  const role = roleService.getCurrentUserRole();
  const target = role != null ? roleService.getDefaultRoute(role) : '/dashboard';
  return new RedirectCommand(router.createUrlTree([target]), { replaceUrl: true });
};
